import React from 'react'
import { Star, Users, Clock } from 'lucide-react'

const SocialProof = () => {
  const testimonials = [
    {
      quote:
        'I haven\'t missed a day in 47 days — something I couldn\'t achieve in 10 years of trying. The Pod leaderboard is weirdly motivating. When I see Naledi at 50 days, I want to catch up. ZoeLive Prayer made prayer competitive in the best way possible.',
      name: 'Thabo Mokoena',
      title: 'Marketing Coordinator',
      location: 'Johannesburg',
      initials: 'TM',
      badge: '47-Day Streak',
      rating: 5,
    },
    {
      quote:
        'As a mom of three, I\'d always say "I\'ll pray later" then collapse into bed. The 10-minute devotions fit perfectly during the kids\' nap time. The app literally locks my phone so I can\'t "just check" Instagram. It\'s the accountability I didn\'t know I needed.',
      name: 'Lerato Nkosi',
      title: 'Primary School Teacher & Mom',
      location: 'Cape Town',
      initials: 'LN',
      badge: 'Premium Subscriber',
      rating: 5,
    },
    {
      quote:
        'I moved to Stellenbosch for a remote job and felt spiritually isolated. My Prayer Pod has people from 3 provinces I\'ve never met in person, but we pray together daily. The encouragement messages when I hit 30 days made me cry. This app gave me community when I had none.',
      name: 'Sipho Dlamini',
      title: 'Software Developer',
      location: 'Stellenbosch',
      initials: 'SD',
      badge: 'Pod Leader',
      rating: 5,
    },
  ]

  const stats = [
    { icon: Star, value: '4.8 App Store', subtitle: '12,247 Reviews' },
    { icon: Star, value: '4.7 Google Play', subtitle: '8,492 Reviews' },
    { icon: Users, value: '127K+ Users', subtitle: 'Across 47 Countries' },
    { icon: Clock, value: '2.1M Minutes', subtitle: 'Prayed This Month' },
  ]

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        {/* Headline */}
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-heading-dark mb-4">
            Real Believers. Real <span className="text-gradient">Transformation</span>.
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="card animate-on-scroll"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Rating Stars */}
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} className="fill-streak-gold text-streak-gold" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-body-gray leading-relaxed mb-6 italic">
                &ldquo;{testimonial.quote}&rdquo;
              </p>

              {/* Author Info */}
              <div className="border-t border-grace-gray pt-4">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-prayer-blue to-pod-green flex items-center justify-center">
                    <span className="text-white text-sm font-bold">{testimonial.initials}</span>
                  </div>
                  <div>
                    <div className="font-bold text-heading-dark">{testimonial.name}</div>
                    <div className="text-sm text-muted-gray">{testimonial.title}</div>
                    <div className="text-sm text-muted-gray">{testimonial.location}</div>
                  </div>
                </div>
                <div className="inline-block text-xs font-semibold text-prayer-blue bg-prayer-blue/10 rounded-full py-1 px-3 mt-2">
                  {testimonial.badge}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto mb-12 animate-on-scroll">
          {stats.map((stat, index) => {
            const Icon = stat.icon
            return (
              <div key={index} className="text-center">
                <Icon size={32} className="text-prayer-blue mx-auto mb-2" />
                <div className="text-xl md:text-2xl font-bold text-heading-dark mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-muted-gray">{stat.subtitle}</div>
              </div>
            )
          })}
        </div>

        {/* Press Mentions */}
        <div className="text-center animate-on-scroll">
          <p className="text-sm text-muted-gray mb-4">AS FEATURED IN</p>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {['JOY! Digital', 'Gateway News', 'Juig!'].map((publication) => (
              <div key={publication} className="text-lg font-semibold text-muted-gray opacity-60">
                {publication}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SocialProof
